import { HttpErrorResponse } from '@angular/common/http';
import { Brand, MetaData } from '@emi/shared/models';
import { createAction, props } from '@ngrx/store';

export const getBrands = createAction('[BrandFilters] Get Brands');

export const getBrandsSuccess = createAction(
    '[BrandFilters] Get Brands Success',
    props<{ brands: Brand[]; metadata: MetaData | null; searchText: string | null }>()
);

export const getBrandsFailure = createAction('[BrandFilters] Get Brands Failure', props<{ error: HttpErrorResponse }>());

export const fetchBrands = createAction('[BrandFilters] Fetch Brands');

export const searchBrands = createAction('[BrandFilters] Get Brands With Search', props<{ searchText: string; delay: number }>());

export const isLoadingBrands = createAction('[BrandFilters] Loading Brands');

export const amendBrandSelections = createAction('[BrandFilters] Amend Selected Brands');

export const getNextPageBrands = createAction('[BrandFilters] Get Next Page Brands');

export const updateBrandsSelectionSuccess = createAction(
    '[BrandFilters] Get Next Page Brands Success',
    props<{ brands: Brand[]; metadata: MetaData | null }>()
);
